// Shared share-sheet helper — extracted from LocationDetail so trails,
// campsites and basecamps all use the exact same native-share → clipboard
// fallback flow (with telemetry attribution per surface).
import { toast } from "sonner";
import { track } from "./telemetry";

export async function shareLink({ url, title, text, event, props = {} }) {
  const payload = { title, text, url };
  if (navigator.share) {
    try {
      await navigator.share(payload);
      track(event, { ...props, method: "native" });
      return;
    } catch (err) {
      if (err && err.name === "AbortError") return;
    }
  }
  try {
    await navigator.clipboard.writeText(url);
    toast.success("Link copied to clipboard!");
    track(event, { ...props, method: "clipboard" });
  } catch {
    toast.error("Couldn't share — copy the URL from your browser bar");
  }
}

// Post-contribution "Share your walk" CTA — interactive success toast shown
// after a Scout rating or photo upload. The action button triggers the exact
// same shareLink flow as the main page share buttons.
export function shareCtaToast({ url, title, text, event, props = {}, description }) {
  toast.success("Thanks for scouting! Share this walk with your pack.", {
    description,
    duration: 8000,
    action: {
      label: "Share",
      onClick: () => shareLink({ url, title, text, event, props }),
    },
  });
}
